import { IonButton } from "@ionic/react";
import { useEffect, useState } from "react";
import { makePOSTRequest } from "../../request/rawRequest";

interface Props {
  idVideo: string;
  idTheme: string;
}

const NextVideo: React.FC<Props> = ({ idVideo, idTheme }) => {
  const [newHref, setNewHref] = useState<string>("");

  const getNextID = async () => {
    await makePOSTRequest("/videos", { _id: [idVideo] }).then(async (video) => {
      await makePOSTRequest("/themes", { _id: idTheme }).then(async (theme) => {
        const promises = theme[0].id_videos.map((videoID: string) =>
          makePOSTRequest("/videos", { _id: [videoID] })
        );

        await Promise.all(promises).then((videos) => {
          const videosIndex = videos
            .map((videoTemp) => ({
              index: videoTemp[0].index,
              _id: videoTemp[0]._id,
            }))
            .filter((v) => v._id !== idVideo.toString());

          let differenceMin = Infinity;
          let nextVideo: any = undefined;

          for (const videoIndex of videosIndex) {
            let difference = videoIndex.index - video[0].index;
            if (difference > 0 && difference < differenceMin) {
              differenceMin = difference;
              nextVideo = videoIndex;
            }
          }
          if (nextVideo !== undefined)
            setNewHref(`theme=${idTheme}&id=${nextVideo._id}`);
        });
      });
    });
  };

  useEffect(() => {
    if (idVideo) getNextID();
  }, [idVideo]);

  return (
    <IonButton
      style={{ fontSize: 20, width: "50%" }}
      shape="round"
      color="secondary"
      onClick={() => {
        window.location.href = "video?" + newHref;
      }}
      disabled={newHref.length <= 0}
    >
      Thème suivant
    </IonButton>
  );
};

export default NextVideo;
